import React from 'react';
import ReactOnRails from 'react-on-rails';

const POLL_INTERVAL = 1500;

class JitSyncPending extends React.Component {
  constructor(props) {
    super(props);
    this.state = { status: 'pending', message: 'Syncing with home office...' };
    this.pollRef = null;
  }

  componentDidMount() {
    // Inject spinner keyframes
    if (!document.getElementById('jit-spin-keyframes')) {
      const style = document.createElement('style');
      style.id = 'jit-spin-keyframes';
      style.textContent = '@keyframes jit-spin { 0% { transform: rotate(0deg); } 100% { transform: rotate(360deg); } }';
      document.head.appendChild(style);
    }

    this.pollRef = setInterval(() => this.pollStatus(), POLL_INTERVAL);
  }

  componentWillUnmount() {
    if (this.pollRef) {
      clearInterval(this.pollRef);
    }
  }

  pollStatus() {
    fetch('/jit_sync/status.json', {
      credentials: 'same-origin',
      headers: { 'Accept': 'application/json' },
    })
      .then((response) => {
        if (!response.ok) return;
        return response.json();
      })
      .then((data) => {
        if (!data) return;

        if (data.status === 'completed') {
          clearInterval(this.pollRef);
          this.pollRef = null;
          this.setState({ status: 'completed', message: 'Account synced successfully! Redirecting...' });
          setTimeout(() => { window.location.href = '/jit_sync/pending'; }, 1200);
        } else if (data.status === 'failed') {
          clearInterval(this.pollRef);
          this.pollRef = null;
          this.setState({ status: 'failed', message: data.message || 'Unable to sync your account data.' });
        } else {
          this.setState({ status: data.status || 'running', message: data.message || 'Syncing with home office...' });
        }
      })
      .catch(() => {
        // Silently retry on next interval
      });
  }

  render() {
    const { status, message } = this.state;

    return (
      <div style={styles.container}>
        <div style={styles.card}>
          {status === 'failed' ? (
            <React.Fragment>
              <div style={styles.iconError}>
                <svg width="48" height="48" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                  <circle cx="12" cy="12" r="10" />
                  <line x1="15" y1="9" x2="9" y2="15" />
                  <line x1="9" y1="9" x2="15" y2="15" />
                </svg>
              </div>
              <h2 style={styles.title}>Account Setup Issue</h2>
              <p style={styles.message}>{message}</p>
              <button style={styles.retryButton} onClick={() => window.location.reload()}>
                Try Again
              </button>
            </React.Fragment>
          ) : status === 'completed' ? (
            <React.Fragment>
              <div style={styles.iconSuccess}>
                <svg width="48" height="48" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                  <circle cx="12" cy="12" r="10" />
                  <polyline points="9 12 12 15 16 10" />
                </svg>
              </div>
              <h2 style={styles.title}>All Set!</h2>
              <p style={styles.message}>{message}</p>
            </React.Fragment>
          ) : (
            <React.Fragment>
              <div style={styles.spinner} />
              <h2 style={styles.title}>Syncing With Home Office</h2>
              <p style={styles.message}>{message}</p>
              <p style={styles.subtext}>This usually takes just a moment. Please do not navigate away.</p>
            </React.Fragment>
          )}
        </div>
      </div>
    );
  }
}

const styles = {
  container: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    minHeight: '100vh',
    backgroundColor: '#f8f9fa',
    padding: '20px',
  },
  card: {
    backgroundColor: '#ffffff',
    borderRadius: '12px',
    padding: '48px',
    textAlign: 'center',
    maxWidth: '480px',
    width: '100%',
    boxShadow: '0 4px 24px rgba(0, 0, 0, 0.08)',
  },
  title: {
    fontSize: '24px',
    fontWeight: '600',
    color: '#1a1a2e',
    margin: '24px 0 12px',
  },
  message: {
    fontSize: '16px',
    color: '#555',
    margin: '0 0 8px',
    lineHeight: '1.5',
  },
  subtext: {
    fontSize: '14px',
    color: '#888',
    margin: '8px 0 0',
  },
  spinner: {
    width: '48px',
    height: '48px',
    border: '4px solid #e0e0e0',
    borderTop: '4px solid #5489B6',
    borderRadius: '50%',
    margin: '0 auto',
    animation: 'jit-spin 1s linear infinite',
  },
  iconError: {
    color: '#e74c3c',
    margin: '0 auto',
    width: '48px',
  },
  iconSuccess: {
    color: '#27ae60',
    margin: '0 auto',
    width: '48px',
  },
  retryButton: {
    marginTop: '24px',
    padding: '12px 32px',
    backgroundColor: '#5489B6',
    color: '#ffffff',
    border: 'none',
    borderRadius: '8px',
    fontSize: '16px',
    fontWeight: '500',
    cursor: 'pointer',
  },
};

export default JitSyncPending;
